import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import Congratulation from "./components/congratulation";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ProgrammPage from "./components/programm";



function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/programm" element={<ProgrammPage />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/offer" element={<Offer />} />
                <Route path="/congratulation" element={<Congratulation />} />
            </Routes>
        </BrowserRouter>

    </div>
  );
}

export default App;
